import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ClientResponse, CreateClientRequest, UpdateClientRequest } from '../types/domain';

export interface ClientFilters { status?: string; search?: string; }

export function clientEndpoints(http: HttpClient) {
  return {
    list: (filters: ClientFilters = {}) => http.get<ApiEnvelope<ClientResponse[]>>('/v1/clients', { query: { status: filters.status, search: filters.search } }).then(unwrap),
    get: (id: string) => http.get<ApiEnvelope<ClientResponse>>(`/v1/clients/${id}`).then(unwrap),
    create: (body: CreateClientRequest) => http.post<ApiEnvelope<ClientResponse>>('/v1/clients', body).then(unwrap),
    update: (id: string, body: UpdateClientRequest) => http.put<ApiEnvelope<ClientResponse>>(`/v1/clients/${id}`, body).then(unwrap),
    remove: (id: string) => http.del<ApiEnvelope<void>>(`/v1/clients/${id}`).then(unwrap),
  };
}
export type ClientEndpoints = ReturnType<typeof clientEndpoints>;
